webpackJsonp([1],{

/***/ 280:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_login__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_success__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_success___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_success__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_404__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_404___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_404__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'login',
    component: __WEBPACK_IMPORTED_MODULE_2__views_login___default.a
  }, {
    path: '/success',
    name: 'success',
    component: __WEBPACK_IMPORTED_MODULE_3__views_success___default.a
  }, {
    path: '/404',
    name: '404',
    component: __WEBPACK_IMPORTED_MODULE_4__views_404___default.a
  }]
});
router.beforeEach(function (to, from, next) {
  console.log(to);
  if (to.name == "login") {}
  next();
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 281:
/***/ (function(module, exports) {

;(function (win, lib) {
    var doc = win.document;
    var docEl = doc.documentElement;
    var metaEl = doc.querySelector('meta[name="viewport"]');
    var flexibleEl = doc.querySelector('meta[name="flexible"]');
    var dpr = 0;
    var scale = 0;
    var tid;
    var flexible = lib.flexible || (lib.flexible = {});

    if (metaEl) {
        var match = metaEl.getAttribute('content').match(/initial\-scale=([\d\.]+)/);
        if (match) {
            scale = parseFloat(match[1]);
            dpr = parseInt(1 / scale);
        }
    } else if (flexibleEl) {
        var content = flexibleEl.getAttribute('content');
        if (content) {
            var initialDpr = content.match(/initial\-dpr=([\d\.]+)/);
            var maximumDpr = content.match(/maximum\-dpr=([\d\.]+)/);
            if (initialDpr) {
                dpr = parseFloat(initialDpr[1]);
                scale = parseFloat((1 / dpr).toFixed(2));
            }
            if (maximumDpr) {
                dpr = parseFloat(maximumDpr[1]);
                scale = parseFloat((1 / dpr).toFixed(2));
            }
        }
    }

    if (!dpr && !scale) {
        var isAndroid = win.navigator.appVersion.match(/android/gi);
        var isIPhone = win.navigator.appVersion.match(/iphone/gi);
        var devicePixelRatio = win.devicePixelRatio;
        if (isIPhone) {
            if (devicePixelRatio >= 3 && (!dpr || dpr >= 3)) {
                dpr = 3;
            } else if (devicePixelRatio >= 2 && (!dpr || dpr >= 2)) {
                dpr = 2;
            } else {
                dpr = 1;
            }
        } else {
            dpr = 1;
        }
        scale = 1 / dpr;
    }

    docEl.setAttribute('data-dpr', dpr);
    if (!metaEl) {
        metaEl = doc.createElement('meta');
        metaEl.setAttribute('name', 'viewport');
        metaEl.setAttribute('content', 'initial-scale=' + scale + ', maximum-scale=' + scale + ', minimum-scale=' + scale + ', user-scalable=no');
        if (docEl.firstElementChild) {
            docEl.firstElementChild.appendChild(metaEl);
        } else {
            var wrap = doc.createElement('div');
            wrap.appendChild(metaEl);
            doc.write(wrap.innerHTML);
        }
    }

    function refreshRem() {
        var width = docEl.getBoundingClientRect().width;
        if (width / dpr > 750) {
            width = 750 * dpr;
        }
        var rem = width / 7.5;
        docEl.style.fontSize = rem + 'px';
        flexible.rem = win.rem = rem;
    }

    win.addEventListener('resize', function () {
        clearTimeout(tid);
        tid = setTimeout(refreshRem, 300);
    }, false);
    win.addEventListener('pageshow', function (e) {
        if (e.persisted) {
            clearTimeout(tid);
            tid = setTimeout(refreshRem, 300);
        }
    }, false);

    if (doc.readyState === 'complete') {
        doc.body.style.fontSize = 12 * dpr + 'px';
    } else {
        doc.addEventListener('DOMContentLoaded', function (e) {
            doc.body.style.fontSize = 12 * dpr + 'px';
        }, false);
    }

    refreshRem();

    flexible.dpr = win.dpr = dpr;
    flexible.refreshRem = refreshRem;
    flexible.rem2px = function (d) {
        var val = parseFloat(d) * this.rem;
        if (typeof d === 'string' && d.match(/rem$/)) {
            val += 'px';
        }
        return val;
    };
    flexible.px2rem = function (d) {
        var val = parseFloat(d) / this.rem;
        if (typeof d === 'string' && d.match(/px$/)) {
            val += 'rem';
        }
        return val;
    };
})(window, window['lib'] || (window['lib'] = {}));

var _hmt = _hmt || [];
(function () {
    var hm = document.createElement("script");
    hm.src = "//hm.baidu.com/hm.js?11bc34ee5d80f0e96f92e2ba2a4098d8";
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(hm, s);
})();

(function () {
    var hm = document.createElement("script");
    hm.src = "//s11.cnzz.com/z_stat.php?id=1261404099&web_id=1261404099";
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(hm, s);
})();

/***/ }),

/***/ 283:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 284:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 285:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 286:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 287:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 293:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(423)

var Component = __webpack_require__(25)(
  /* script */
  __webpack_require__(342),
  /* template */
  __webpack_require__(506),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 294:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(421)

var Component = __webpack_require__(25)(
  /* script */
  __webpack_require__(343),
  /* template */
  __webpack_require__(504),
  /* scopeId */
  "data-v-1b739e30",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 341:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    width: {
      type: Number,
      default: 800
    },
    height: {
      type: Number,
      default: 300
    },
    lineWidth: {
      type: Number,
      default: 4
    },
    lineColor: {
      type: String,
      default: '#000000'
    },
    bgColor: {
      type: String,
      default: ''
    },
    isCrop: {
      type: Boolean,
      default: false
    },
    isClearBgColor: {
      type: Boolean,
      default: true
    },
    format: {
      type: String,
      default: 'image/png'
    },
    quality: {
      type: Number,
      default: 1
    }
  },
  data: function data() {
    return {
      hasDrew: false,
      resultImg: '',
      points: [],
      canvasTxt: null,
      startX: 0,
      startY: 0,
      isDrawing: false,
      sratio: 1
    };
  },

  computed: {
    ratio: function ratio() {
      return this.height / this.width;
    },
    stageInfo: function stageInfo() {
      return this.$refs.canvas.getBoundingClientRect();
    },
    myBg: function myBg() {
      return this.bgColor ? this.bgColor : 'rgba(255, 255, 255, 0)';
    }
  },
  watch: {
    'myBg': function myBg(newVal) {
      this.$refs.canvas.style.background = newVal;
    }
  },
  beforeMount: function beforeMount() {
    window.addEventListener('resize', this.$_resizeHandler);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.$_resizeHandler);
  },
  mounted: function mounted() {
    var _this = this;

    var canvas = this.$refs.canvas;
    canvas.height = this.height;
    canvas.width = this.width;
    canvas.style.background = this.myBg;
    this.$_resizeHandler();
    // 在画板以外松开鼠标后冻结画笔
    document.onmouseup = function () {
      _this.isDrawing = false;
    };
  },

  methods: {
    $_resizeHandler: function $_resizeHandler() {
      var canvas = this.$refs.canvas;
      canvas.style.width = this.width + "px";
      var realw = parseFloat(window.getComputedStyle(canvas).width);
      canvas.style.height = this.ratio * realw + "px";
      this.canvasTxt = canvas.getContext('2d');
      this.canvasTxt.scale(1 * this.sratio, 1 * this.sratio);
      this.sratio = realw / this.width;
      this.canvasTxt.scale(1 / this.sratio, 1 / this.sratio);
    },

    // pc
    mouseDown: function mouseDown(e) {
      e = e || event;
      e.preventDefault();
      this.isDrawing = true;
      this.hasDrew = true;
      var obj = {
        x: e.offsetX,
        y: e.offsetY
      };
      this.drawStart(obj);
    },
    mouseMove: function mouseMove(e) {
      e = e || event;
      e.preventDefault();
      if (this.isDrawing) {
        var obj = {
          x: e.offsetX,
          y: e.offsetY
        };
        this.drawMove(obj);
      }
    },
    mouseUp: function mouseUp(e) {
      e = e || event;
      e.preventDefault();
      var obj = {
        x: e.offsetX,
        y: e.offsetY
      };
      this.drawEnd(obj);
      this.isDrawing = false;
    },

    // mobile
    touchStart: function touchStart(e) {
      e = e || event;
      e.preventDefault();
      this.hasDrew = true;
      if (e.touches.length === 1) {
        var obj = {
          x: e.targetTouches[0].clientX - this.$refs.canvas.getBoundingClientRect().left,
          y: e.targetTouches[0].clientY - this.$refs.canvas.getBoundingClientRect().top
        };
        this.drawStart(obj);
      }
    },
    touchMove: function touchMove(e) {
      e = e || event;
      e.preventDefault();
      if (e.touches.length === 1) {
        var obj = {
          x: e.targetTouches[0].clientX - this.$refs.canvas.getBoundingClientRect().left,
          y: e.targetTouches[0].clientY - this.$refs.canvas.getBoundingClientRect().top
        };
        this.drawMove(obj);
      }
    },
    touchEnd: function touchEnd(e) {
      e = e || event;
      e.preventDefault();
      if (e.touches.length === 1) {
        var obj = {
          x: e.targetTouches[0].clientX - this.$refs.canvas.getBoundingClientRect().left,
          y: e.targetTouches[0].clientY - this.$refs.canvas.getBoundingClientRect().top
        };
        this.drawEnd(obj);
      }
    },

    // 绘制
    drawStart: function drawStart(obj) {
      this.startX = obj.x;
      this.startY = obj.y;
      this.canvasTxt.beginPath();
      this.canvasTxt.moveTo(this.startX, this.startY);
      this.canvasTxt.lineTo(obj.x, obj.y);
      this.canvasTxt.lineCap = 'round';
      this.canvasTxt.lineJoin = 'round';
      this.canvasTxt.lineWidth = this.lineWidth * this.sratio;
      this.canvasTxt.stroke();
      this.canvasTxt.closePath();
      this.points.push(obj);
    },
    drawMove: function drawMove(obj) {
      this.canvasTxt.beginPath();
      this.canvasTxt.moveTo(this.startX, this.startY);
      this.canvasTxt.lineTo(obj.x, obj.y);
      this.canvasTxt.strokeStyle = this.lineColor;
      this.canvasTxt.lineWidth = this.lineWidth * this.sratio;
      this.canvasTxt.lineCap = 'round';
      this.canvasTxt.lineJoin = 'round';
      this.canvasTxt.stroke();
      this.canvasTxt.closePath();
      this.startY = obj.y;
      this.startX = obj.x;
      this.points.push(obj);
    },
    drawEnd: function drawEnd(obj) {
      this.canvasTxt.beginPath();
      this.canvasTxt.moveTo(this.startX, this.startY);
      this.canvasTxt.lineTo(obj.x, obj.y);
      this.canvasTxt.lineCap = 'round';
      this.canvasTxt.lineJoin = 'round';
      this.canvasTxt.stroke();
      this.canvasTxt.closePath();
      this.points.push(obj);
      this.points.push({ x: -1, y: -1 });
    },

    // 操作
    generate: function generate(options) {
      var _this2 = this;

      var imgFormat = options && options.format ? options.format : this.format;
      var imgQuality = options && options.quality ? options.quality : this.quality;
      var pm = new Promise(function (resolve, reject) {
        if (!_this2.hasDrew) {
          reject('Warning: Not Signned!');
          return;
        }
        var resImgData = _this2.canvasTxt.getImageData(0, 0, _this2.$refs.canvas.width, _this2.$refs.canvas.height);
        _this2.canvasTxt.globalCompositeOperation = "destination-over";
        _this2.canvasTxt.fillStyle = _this2.myBg;
        _this2.canvasTxt.fillRect(0, 0, _this2.$refs.canvas.width, _this2.$refs.canvas.height);
        _this2.resultImg = _this2.$refs.canvas.toDataURL(imgFormat, imgQuality);
        var resultImg = _this2.resultImg;
        _this2.canvasTxt.clearRect(0, 0, _this2.$refs.canvas.width, _this2.$refs.canvas.height);
        _this2.canvasTxt.putImageData(resImgData, 0, 0);
        _this2.canvasTxt.globalCompositeOperation = "source-over";
        if (_this2.isCrop) {
          var _canvasTxt;

          var crop_area = _this2.getCropArea(resImgData.data);
          var crop_canvas = document.createElement('canvas');
          var crop_ctx = crop_canvas.getContext('2d');
          crop_canvas.width = crop_area[2] - crop_area[0];
          crop_canvas.height = crop_area[3] - crop_area[1];
          var crop_imgData = (_canvasTxt = _this2.canvasTxt).getImageData.apply(_canvasTxt, _toConsumableArray(crop_area));
          crop_ctx.globalCompositeOperation = "destination-over";
          crop_ctx.putImageData(crop_imgData, 0, 0);
          crop_ctx.fillStyle = _this2.myBg;
          crop_ctx.fillRect(0, 0, crop_canvas.width, crop_canvas.height);
          resultImg = crop_canvas.toDataURL(imgFormat, imgQuality);
          crop_canvas = null;
        }
        resolve(resultImg);
      });
      return pm;
    },
    reset: function reset() {
      this.canvasTxt.clearRect(0, 0, this.$refs.canvas.width, this.$refs.canvas.height);
      if (this.isClearBgColor) {
        this.$emit('update:bgColor', '');
        this.$refs.canvas.style.background = 'rgba(255, 255, 255, 0)';
      }
      this.points = [];
      this.hasDrew = false;
      this.resultImg = '';
    },
    getCropArea: function getCropArea(imgData) {
      var topX = this.$refs.canvas.width;var btmX = 0;var topY = this.$refs.canvas.height;var btnY = 0;
      for (var i = 0; i < this.$refs.canvas.width; i++) {
        for (var j = 0; j < this.$refs.canvas.height; j++) {
          var pos = (i + this.$refs.canvas.width * j) * 4;
          if (imgData[pos] > 0 || imgData[pos + 1] > 0 || imgData[pos + 2] || imgData[pos + 3] > 0) {
            btnY = Math.max(j, btnY);
            btmX = Math.max(i, btmX);
            topY = Math.min(j, topY);
            topX = Math.min(i, topX);
          }
        }
      }
      topX++;
      btmX++;
      topY++;
      btnY++;
      var data = [topX, topY, btmX, btnY];
      return data;
    }
  }
});

/***/ }),

/***/ 342:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {},
  beforeCreate: function beforeCreate() {
    console.log("%c Powered by Zhaohui - microzz.com", "background-image:-webkit-gradient( linear, left top,right top, color-stop(0, #00a419),color-stop(0.15, #f44336), color-stop(0.29, #ff4300),color-stop(0.3, #AA00FF),color-stop(0.4, #8BC34A), color-stop(0.45, #607D8B),color-stop(0.6, #4096EE), color-stop(0.75, #D50000),color-stop(0.9, #4096EE), color-stop(1, #FF1A00));color:transparent;-webkit-background-clip:text;font-size:13px;");
  },
  created: function created() {
    sessionStorage.addr = '未知';
  }
});

/***/ }),

/***/ 343:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_index__ = __webpack_require__(348);



/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'SignCanvas',
	components: {},

	props: {
		width: {
			type: Number,
			default: function _default() {
				var dom = document.querySelector('#app');
				var width = dom && dom.offsetWidth;
				return width ? width - 115 : 300;
			}
		},

		height: {
			type: Number,
			default: function _default() {
				var dom = document.querySelector('#app');

				return dom && dom.offsetHeight ? dom && dom.offsetHeight - 30 : 800;
			}
		},

		lineWidth: {
			type: Number,
			default: 6
		},

		lineColor: {
			type: String,
			default: '#000'
		},

		bgColor: {
			type: String,
			default: '#F3F3F3'
		},

		isCrop: {
			type: Boolean,
			default: false
		},

		isClearBgColor: {
			type: Boolean,
			default: true
		},

		format: {
			type: String,
			default: 'image/png'
		},

		quality: {
			type: Number,
			default: 1
		},

		noSignTipText: {
			type: String,
			default: '请确保已签名！'
		},

		signName: {
			type: String,
			default: ''
		}
	},

	methods: {
		resetHandler: function resetHandler() {
			this.$refs.VueEsignRef.reset();
		},
		clearHandler: function clearHandler() {
			this.$emit('clearHandler');
			this.resetHandler();
		},
		sureHandler: function sureHandler() {
			var _this = this;

			this.$refs.VueEsignRef.generate().then(function (res) {
				__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_index__["a" /* rotateBase64Img */])(res, 270, '' + (_this.signName ? _this.signName + '-签名.jpg' : 'sign.jpg'), '', function (data) {
					_this.$emit('sureHandler', data);
				});
			}).catch(function (err) {
				console.log('err----', err);
			});
		}
	}
});

/***/ }),

/***/ 344:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),

/***/ 345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(92);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "BloodRegisterSign",
  components: {},

  data: function data() {
    return {
      actionId: "",
      codeTime: "",
      uploadFlag: true,
      inputData: {},
      nameIndex: 0,
      signFileList: [] };
  },


  computed: {
    nameList: function nameList() {
      return this.inputData.cxmjView ? this.inputData.cxmjView.split(",") : [];
    }
  },

  watch: {},

  created: function created() {
    var url = window.location.href;
    console.log(url);
    var dz_url = url.split("#")[0];
    console.log(dz_url);
    var cs = dz_url.split("?")[1];
    console.log(cs);
    var cs_arr = cs.split("&");
    var cs = {};
    for (var i = 0; i < cs_arr.length; i++) {
      cs[cs_arr[i].split("=")[0]] = cs_arr[i].split("=")[1];
    }


    console.log(cs.actionId);
    this.actionId = cs.actionId;
    if (cs.platform != undefined && cs.platform == "queue") {
      var that = this;
      that.uploadFlag = true;
    } else {
      var that = this;
      that.uploadFlag = true;
      console.log(new Date().getTime());

      that.codeTime = 60 - (new Date().getTime() - cs.time) / 1000;
      console.log(that.codeTime);
      var timer = setInterval(function () {
        if (that.codeTime <= 0) {
          that.uploadFlag = false;
          clearInterval(timer);
        } else {
          that.codeTime--;
          console.log(that.codeTime);
        }
      }, 1000);
    }

    this.inputData = JSON.parse(this.$route.query.inputData || "{}");
  },


  methods: {
    GetUrlParam: function GetUrlParam(paraName) {
      var url = document.location.toString();
      var arrObj = url.split("?");
      if (arrObj.length > 1) {
        var arrPara = arrObj[1].split("&");
        var arr;
        for (var i = 0; i < arrPara.length; i++) {
          arr = arrPara[i].split("=");

          if (arr != null && arr[0] == paraName) {
            return arr[1];
          }
        }
        return "";
      } else {
        return "";
      }
    },
    sureSignHandler: function sureSignHandler(data) {
      var that = this;
      console.log(that.uploadFlag);
      if (!this.uploadFlag) {
        console.log("二维码已过期，请重新刷新并扫码");
        var instance = that.$toast({
          message: "二维码已过期，请重新刷新并扫码",
          className: "toastClass",
          position: "bottom",

          duration: 2000
        });
        return;
      }
      var formData = new FormData();
      formData.append("file", data);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* fileUpload */])(formData).then(function (res) {
        console.log(res);
        if (res.data.success) {
          var _instance = that.$toast({
            message: "提交成功",
            className: "toastClass",
            position: "bottom",

            duration: 2000
          });
          that.submitHandler(res.data.pic_url);
        } else {
          var _instance2 = that.$toast({
            message: "提交失败",
            className: "toastClass",
            position: "bottom",

            duration: 2000
          });
        }
      });
    },
    submitHandler: function submitHandler(picUrl) {
      var _this = this;

      var that = this;
      var url = window.location.href;
      console.log(url);
      var dz_url = url.split("#")[0];
      console.log(dz_url);
      var cs = dz_url.split("?")[1];
      console.log(cs);
      var cs_arr = cs.split("&");
      var cs = {};
      for (var i = 0; i < cs_arr.length; i++) {
        cs[cs_arr[i].split("=")[0]] = cs_arr[i].split("=")[1];
      }
      var obj = {
        actionId: this.actionId,
        picUrl: picUrl,
        picType: 41,
        fileName: "signPic" };
      if (cs.platform == "queueDoctor") {
        obj.picType = 42;
      }
      if (cs.platform == "edc") {
        obj.picType = 202;
      }
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["b" /* insertPic */])(obj).then(function (res) {
        if (res.data.status) {
          var instance = that.$toast({
            message: "提交成功",
            position: "bottom",
            className: "toastClass",

            duration: 2000
          });

          if (cs.platform != undefined && cs.platform == "queue") {
            if (cs.evn != undefined && cs.evn == "dev") {
              window.location.href = "https://ky.docteams.cn/devpatient/#/queue/applyGroup?studyId=" + cs.studyId;
            } else {
              window.location.href = "https://ky.docteams.cn/patient/#/queue/applyGroup?studyId=" + cs.studyId;
            }
          } else if (cs.platform != undefined && cs.platform == "queueDoctor") {
            if (cs.evn != undefined && cs.evn == "dev") {
              window.location.href = "https://ky.docteams.cn/devpatient/#/doctorSignSuccess?studyId=" + cs.studyId + "&actionId=" + _this.actionId + "&patientGroupId=" + cs.patientGroupId + "&teamsId=" + cs.teamsId;
            } else {
              window.location.href = "https://ky.docteams.cn/patient/#/doctorSignSuccess?studyId=" + cs.studyId + "&actionId=" + _this.actionId + "&patientGroupId=" + cs.patientGroupId + "&teamsId=" + cs.teamsId;
            }
          } else if (cs.platform != undefined && cs.platform == "edc") {
            that.$router.push("success");
          } else {
            that.$router.push("success");
          }
        } else {
          that.$toast({
            message: "提交失败",
            position: "bottom",
            className: "toastClass",
            duration: 2000
          });
        }
      });
    }
  }
});

/***/ }),

/***/ 346:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(92);



/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'BloodRegisterSign',
	components: {},

	data: function data() {
		return {
			codeTime: '',
			uploadFlag: true,
			inputData: {},
			nameIndex: 0,
			signFileList: [] };
	},


	computed: {
		nameList: function nameList() {
			return this.inputData.cxmjView ? this.inputData.cxmjView.split(',') : [];
		}
	},

	watch: {},

	created: function created() {},


	methods: {
		sureSignHandler: function sureSignHandler(data) {
			var that = this;
			console.log(that.uploadFlag);
			if (!this.uploadFlag) {
				console.log('二维码已过期，请重新刷新并扫码');
				var instance = that.$toast({
					message: '二维码已过期，请重新刷新并扫码',
					className: 'toastClass',
					position: "bottom",

					duration: 2000
				});
				return;
			}
			var formData = new FormData();
			formData.append('file', data);
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* fileUpload */])(formData).then(function (res) {
				console.log(res);
				if (res.data.success) {
					var _instance = that.$toast({
						message: '提交成功',
						className: 'toastClass',
						position: "bottom",

						duration: 2000
					});
					that.submitHandler(res.data.pic_url);
				} else {
					var _instance2 = that.$toast({
						message: '提交失败',
						className: 'toastClass',
						position: "bottom",

						duration: 2000
					});
				}
			});
		},
		submitHandler: function submitHandler(url) {
			var obj = {
				actionId: this.$route.query.actionId,
				picUrl: url,
				picType: 41,
				fileName: 'signPic' };
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["b" /* insertPic */])(obj).then(function (res) {
				if (res.data.status) {
					var instance = that.$toast({
						message: '提交成功',
						position: "bottom",
						className: 'toastClass',

						duration: 2000
					});
				} else {
					that.$toast({
						message: res.data.msg,
						position: "bottom",
						className: 'toastClass',
						duration: 2000
					});
				}
			});
		}
	}
});

/***/ }),

/***/ 347:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_axios__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_flexible__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_flexible___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__utils_flexible__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mint_ui__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_mint_ui_lib_style_css__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_mint_ui_lib_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_mint_ui_lib_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_esign__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_scss_index_scss__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_scss_index_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_scss_index_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_SignCanvas__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_SignCanvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_SignCanvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_weixin_js_sdk__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_weixin_js_sdk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_weixin_js_sdk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_video_player__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_video_player___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vue_video_player__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_videojs_flash__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_videojs_contrib_hls__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_videojs_contrib_hls___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_videojs_contrib_hls__);















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_vue_esign__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('SignCanvas', __WEBPACK_IMPORTED_MODULE_14__components_SignCanvas___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$toast = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$toast = __WEBPACK_IMPORTED_MODULE_10_mint_ui__["Toast"];

__WEBPACK_IMPORTED_MODULE_3_moment___default.a.locale('zh-cn');

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.moment = __WEBPACK_IMPORTED_MODULE_3_moment___default.a;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.random = function (n) {
  return Math.floor(n * Math.random());
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_15_weixin_js_sdk___default.a);



__webpack_require__(285);
__webpack_require__(286);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_16_vue_video_player___default.a);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_element_ui___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_5_axios___default.a);

var store = new __WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* default */].Store({
  state: {
    name: '',

    avatarUrl: 'http://omratag7g.bkt.clouddn.com/icon-avatar' + __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.random(21) + '.svg',
    addr: '未知',
    isShowAbout: false
  },

  mutations: {
    changeName: function changeName(state, name) {
      state.name = name;
    },
    setAddr: function setAddr(state, addr) {
      state.addr = addr;
    },
    showAbout: function showAbout(state, flag) {
      state.isShowAbout = flag;
    }
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: store,
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 348:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = rotateBase64Img;
/* unused harmony export dataURLtoFile */

function rotateBase64Img(src, edg, fileName, fileType, callback) {
  var canvas = document.createElement('canvas');
  var ctx = canvas.getContext('2d');

  var imgW;
  var imgH;
  var size;

  if (edg % 90 !== 0) {
    console.error('旋转角度必须是90的倍数!');
    return '旋转角度必须是90的倍数!';
  }
  edg < 0 && (edg = edg % 360 + 360);
  var quadrant = edg / 90 % 4;
  var cutCoor = { sx: 0, sy: 0, ex: 0, ey: 0 };

  var image = new Image();
  image.crossOrigin = 'Anonymous';
  image.src = src;

  image.onload = function () {
    imgW = image.width;
    imgH = image.height;
    size = imgW > imgH ? imgW : imgH;

    canvas.width = size * 2;
    canvas.height = size * 2;
    switch (quadrant) {
      case 0:
        cutCoor.sx = size;
        cutCoor.sy = size;
        cutCoor.ex = size + imgW;
        cutCoor.ey = size + imgH;
        break;
      case 1:
        cutCoor.sx = size - imgH;
        cutCoor.sy = size;
        cutCoor.ex = size;
        cutCoor.ey = size + imgW;
        break;
      case 2:
        cutCoor.sx = size - imgW;
        cutCoor.sy = size - imgH;
        cutCoor.ex = size;
        cutCoor.ey = size;
        break;
      case 3:
        cutCoor.sx = size;
        cutCoor.sy = size - imgW;
        cutCoor.ex = size + imgH;
        cutCoor.ey = size + imgW;
        break;
    }

    ctx.translate(size, size);
    ctx.rotate(edg * Math.PI / 180);
    ctx.drawImage(image, 0, 0);

    var imgData = ctx.getImageData(cutCoor.sx, cutCoor.sy, cutCoor.ex, cutCoor.ey);

    if (quadrant % 2 === 0) {
      canvas.width = imgW;
      canvas.height = imgH;
    } else {
      canvas.width = imgH;
      canvas.height = imgW;
    }

    ctx.putImageData(imgData, 0, 0);
    callback(dataURLtoFile(canvas.toDataURL(), fileName, fileType));
  };
}

function dataURLtoFile(dataURL, fileName, fileType) {
  var arr = dataURL.split(',');
  var mime = arr[0].match(/:(.*?);/)[1];
  var bstr = atob(arr[1]);
  var n = bstr.length;
  var u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], fileName, { type: fileType || 'image/jpg' });
}

/***/ }),

/***/ 349:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);



var service = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
  baseURL: "https://sign.docteams.cn/apis/",
  timeout: 15000 });

service.interceptors.request.use(function (config) {
  return config;
}, function (error) {
  console.log(error);
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

service.interceptors.response.use(function (response) {
  return response;
  var res = response.data;
  console.log(res);
  if (res.code !== 200) {
    Message({
      message: res.message,
      type: 'error',
      duration: 3 * 1000
    });

    if (res.code === 401 || res.code === 403) {
      MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
        confirmButtonText: '重新登录',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        store.dispatch('FedLogOut').then(function () {
          location.reload();
        });
      });
    }
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject('error');
  } else {
    return response.data;
  }
}, function (error) {
  if (error.response.status == 401 || error.response.status == 403) {
    MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
      confirmButtonText: '重新登录',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(function () {
      clearLoginInfo();
    });
  } else if (error.response.status == 500) {
    Message({
      showClose: true,
      message: '服务繁忙，请稍后再试',
      type: 'error',
      duration: 1000
    });
  }
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

/* harmony default export */ __webpack_exports__["a"] = (service);

/***/ }),

/***/ 420:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 421:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 422:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 423:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 424:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 425:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 435:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 124,
	"./af.js": 124,
	"./ar": 132,
	"./ar-dz": 125,
	"./ar-dz.js": 125,
	"./ar-kw": 126,
	"./ar-kw.js": 126,
	"./ar-ly": 127,
	"./ar-ly.js": 127,
	"./ar-ma": 128,
	"./ar-ma.js": 128,
	"./ar-ps": 129,
	"./ar-ps.js": 129,
	"./ar-sa": 130,
	"./ar-sa.js": 130,
	"./ar-tn": 131,
	"./ar-tn.js": 131,
	"./ar.js": 132,
	"./az": 133,
	"./az.js": 133,
	"./be": 134,
	"./be.js": 134,
	"./bg": 135,
	"./bg.js": 135,
	"./bm": 136,
	"./bm.js": 136,
	"./bn": 138,
	"./bn-bd": 137,
	"./bn-bd.js": 137,
	"./bn.js": 138,
	"./bo": 139,
	"./bo.js": 139,
	"./br": 140,
	"./br.js": 140,
	"./bs": 141,
	"./bs.js": 141,
	"./ca": 142,
	"./ca.js": 142,
	"./cs": 143,
	"./cs.js": 143,
	"./cv": 144,
	"./cv.js": 144,
	"./cy": 145,
	"./cy.js": 145,
	"./da": 146,
	"./da.js": 146,
	"./de": 149,
	"./de-at": 147,
	"./de-at.js": 147,
	"./de-ch": 148,
	"./de-ch.js": 148,
	"./de.js": 149,
	"./dv": 150,
	"./dv.js": 150,
	"./el": 151,
	"./el.js": 151,
	"./en-au": 152,
	"./en-au.js": 152,
	"./en-ca": 153,
	"./en-ca.js": 153,
	"./en-gb": 154,
	"./en-gb.js": 154,
	"./en-ie": 155,
	"./en-ie.js": 155,
	"./en-il": 156,
	"./en-il.js": 156,
	"./en-in": 157,
	"./en-in.js": 157,
	"./en-nz": 158,
	"./en-nz.js": 158,
	"./en-sg": 159,
	"./en-sg.js": 159,
	"./eo": 160,
	"./eo.js": 160,
	"./es": 164,
	"./es-do": 161,
	"./es-do.js": 161,
	"./es-mx": 162,
	"./es-mx.js": 162,
	"./es-us": 163,
	"./es-us.js": 163,
	"./es.js": 164,
	"./et": 165,
	"./et.js": 165,
	"./eu": 166,
	"./eu.js": 166,
	"./fa": 167,
	"./fa.js": 167,
	"./fi": 168,
	"./fi.js": 168,
	"./fil": 169,
	"./fil.js": 169,
	"./fo": 170,
	"./fo.js": 170,
	"./fr": 173,
	"./fr-ca": 171,
	"./fr-ca.js": 171,
	"./fr-ch": 172,
	"./fr-ch.js": 172,
	"./fr.js": 173,
	"./fy": 174,
	"./fy.js": 174,
	"./ga": 175,
	"./ga.js": 175,
	"./gd": 176,
	"./gd.js": 176,
	"./gl": 177,
	"./gl.js": 177,
	"./gom-deva": 178,
	"./gom-deva.js": 178,
	"./gom-latn": 179,
	"./gom-latn.js": 179,
	"./gu": 180,
	"./gu.js": 180,
	"./he": 181,
	"./he.js": 181,
	"./hi": 182,
	"./hi.js": 182,
	"./hr": 183,
	"./hr.js": 183,
	"./hu": 184,
	"./hu.js": 184,
	"./hy-am": 185,
	"./hy-am.js": 185,
	"./id": 186,
	"./id.js": 186,
	"./is": 187,
	"./is.js": 187,
	"./it": 189,
	"./it-ch": 188,
	"./it-ch.js": 188,
	"./it.js": 189,
	"./ja": 190,
	"./ja.js": 190,
	"./jv": 191,
	"./jv.js": 191,
	"./ka": 192,
	"./ka.js": 192,
	"./kk": 193,
	"./kk.js": 193,
	"./km": 194,
	"./km.js": 194,
	"./kn": 195,
	"./kn.js": 195,
	"./ko": 196,
	"./ko.js": 196,
	"./ku": 198,
	"./ku-kmr": 197,
	"./ku-kmr.js": 197,
	"./ku.js": 198,
	"./ky": 199,
	"./ky.js": 199,
	"./lb": 200,
	"./lb.js": 200,
	"./lo": 201,
	"./lo.js": 201,
	"./lt": 202,
	"./lt.js": 202,
	"./lv": 203,
	"./lv.js": 203,
	"./me": 204,
	"./me.js": 204,
	"./mi": 205,
	"./mi.js": 205,
	"./mk": 206,
	"./mk.js": 206,
	"./ml": 207,
	"./ml.js": 207,
	"./mn": 208,
	"./mn.js": 208,
	"./mr": 209,
	"./mr.js": 209,
	"./ms": 211,
	"./ms-my": 210,
	"./ms-my.js": 210,
	"./ms.js": 211,
	"./mt": 212,
	"./mt.js": 212,
	"./my": 213,
	"./my.js": 213,
	"./nb": 214,
	"./nb.js": 214,
	"./ne": 215,
	"./ne.js": 215,
	"./nl": 217,
	"./nl-be": 216,
	"./nl-be.js": 216,
	"./nl.js": 217,
	"./nn": 218,
	"./nn.js": 218,
	"./oc-lnc": 219,
	"./oc-lnc.js": 219,
	"./pa-in": 220,
	"./pa-in.js": 220,
	"./pl": 221,
	"./pl.js": 221,
	"./pt": 223,
	"./pt-br": 222,
	"./pt-br.js": 222,
	"./pt.js": 223,
	"./ro": 224,
	"./ro.js": 224,
	"./ru": 225,
	"./ru.js": 225,
	"./sd": 226,
	"./sd.js": 226,
	"./se": 227,
	"./se.js": 227,
	"./si": 228,
	"./si.js": 228,
	"./sk": 229,
	"./sk.js": 229,
	"./sl": 230,
	"./sl.js": 230,
	"./sq": 231,
	"./sq.js": 231,
	"./sr": 233,
	"./sr-cyrl": 232,
	"./sr-cyrl.js": 232,
	"./sr.js": 233,
	"./ss": 234,
	"./ss.js": 234,
	"./sv": 235,
	"./sv.js": 235,
	"./sw": 236,
	"./sw.js": 236,
	"./ta": 237,
	"./ta.js": 237,
	"./te": 238,
	"./te.js": 238,
	"./tet": 239,
	"./tet.js": 239,
	"./tg": 240,
	"./tg.js": 240,
	"./th": 241,
	"./th.js": 241,
	"./tk": 242,
	"./tk.js": 242,
	"./tl-ph": 243,
	"./tl-ph.js": 243,
	"./tlh": 244,
	"./tlh.js": 244,
	"./tr": 245,
	"./tr.js": 245,
	"./tzl": 246,
	"./tzl.js": 246,
	"./tzm": 248,
	"./tzm-latn": 247,
	"./tzm-latn.js": 247,
	"./tzm.js": 248,
	"./ug-cn": 249,
	"./ug-cn.js": 249,
	"./uk": 250,
	"./uk.js": 250,
	"./ur": 251,
	"./ur.js": 251,
	"./uz": 253,
	"./uz-latn": 252,
	"./uz-latn.js": 252,
	"./uz.js": 253,
	"./vi": 254,
	"./vi.js": 254,
	"./x-pseudo": 255,
	"./x-pseudo.js": 255,
	"./yo": 256,
	"./yo.js": 256,
	"./zh-cn": 257,
	"./zh-cn.js": 257,
	"./zh-hk": 258,
	"./zh-hk.js": 258,
	"./zh-mo": 259,
	"./zh-mo.js": 259,
	"./zh-tw": 260,
	"./zh-tw.js": 260
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 435;

/***/ }),

/***/ 472:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/finish.f6e08b0.png";

/***/ }),

/***/ 473:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 493:
/***/ (function(module, exports) {

module.exports = {"_args":[["videojs-swf@5.4.2","D:\\zm\\临床科研\\qianzitongyongxiangmu"]],"_from":"videojs-swf@5.4.2","_id":"videojs-swf@5.4.2","_inBundle":false,"_integrity":"sha512-FGg+Csioa8/A/EacvFefBdb9Z0rSiMlheHDunZnN3xXfUF43jvjawcWFQnZvrv1Cs1nE1LBrHyUZjF7j2mKOLw==","_location":"/videojs-swf","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"videojs-swf@5.4.2","name":"videojs-swf","escapedName":"videojs-swf","rawSpec":"5.4.2","saveSpec":null,"fetchSpec":"5.4.2"},"_requiredBy":["/videojs-flash"],"_resolved":"https://registry.npmmirror.com/videojs-swf/-/videojs-swf-5.4.2.tgz","_spec":"5.4.2","_where":"D:\\zm\\临床科研\\qianzitongyongxiangmu","author":{"name":"Brightcove"},"bugs":{"url":"https://github.com/videojs/video-js-swf/issues"},"copyright":"Copyright 2014 Brightcove, Inc. https://github.com/videojs/video-js-swf/blob/master/LICENSE","description":"The Flash-fallback video player for video.js (http://videojs.com)","devDependencies":{"async":"~0.2.9","chg":"^0.3.2","flex-sdk":"4.6.0-0","grunt":"~0.4.0","grunt-bumpup":"~0.5.0","grunt-cli":"~0.1.0","grunt-connect":"~0.2.0","grunt-contrib-jshint":"~0.4.3","grunt-contrib-qunit":"~0.2.1","grunt-contrib-watch":"~0.1.4","grunt-npm":"~0.0.2","grunt-prompt":"~0.1.2","grunt-shell":"~0.6.1","grunt-tagrelease":"~0.3.1","qunitjs":"~1.12.0","video.js":"^5.9.2"},"homepage":"http://videojs.com","keywords":["flash","video","player"],"name":"videojs-swf","repository":{"type":"git","url":"git+https://github.com/videojs/video-js-swf.git"},"scripts":{"version":"chg release -y && grunt dist && git add -f dist/ && git add CHANGELOG.md"},"version":"5.4.2"}

/***/ }),

/***/ 499:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(420)

var Component = __webpack_require__(25)(
  /* script */
  __webpack_require__(341),
  /* template */
  __webpack_require__(503),
  /* scopeId */
  "data-v-0c901a51",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 500:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(422)

var Component = __webpack_require__(25)(
  /* script */
  __webpack_require__(344),
  /* template */
  __webpack_require__(505),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 501:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(424)

var Component = __webpack_require__(25)(
  /* script */
  __webpack_require__(345),
  /* template */
  __webpack_require__(507),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 502:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(425)

var Component = __webpack_require__(25)(
  /* script */
  __webpack_require__(346),
  /* template */
  __webpack_require__(508),
  /* scopeId */
  "data-v-fc9d0d38",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 503:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('canvas', {
    ref: "canvas",
    on: {
      "mousedown": _vm.mouseDown,
      "mousemove": _vm.mouseMove,
      "mouseup": _vm.mouseUp,
      "touchstart": _vm.touchStart,
      "touchmove": _vm.touchMove,
      "touchend": _vm.touchEnd
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 504:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "signContainer"
  }, [_c('div', {
    staticClass: "btns"
  }, [_c('img', {
    staticClass: "icon1",
    attrs: {
      "src": __webpack_require__(473),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tipDetail2"
  }, [_vm._v("电子签名已做加密处理，请放心使用！")]), _vm._v(" "), _c('div', {
    staticClass: "mybutton1",
    on: {
      "click": _vm.clearHandler
    }
  }, [_vm._v("重签")]), _vm._v(" "), _c('div', {
    staticClass: "mybutton2",
    on: {
      "click": _vm.sureHandler
    }
  }, [_vm._v("确认")])]), _vm._v(" "), _c('vue-esign', {
    ref: "VueEsignRef",
    staticClass: "vue-esign",
    attrs: {
      "width": _vm.width,
      "height": _vm.height,
      "lineWidth": _vm.lineWidth,
      "lineColor": _vm.lineColor,
      "bgColor": _vm.bgColor,
      "isClearBgColor": false,
      "isCrop": _vm.isCrop,
      "format": _vm.format,
      "quality": _vm.quality
    }
  }), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tips"
  }, [_c('div', {
    staticClass: "tipDetail"
  }, [_vm._v(" 请将手机横屏，并且完成签名：")])])
}]}

/***/ }),

/***/ 505:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "site-wrapper site-page--not-found"
  }, [_c('div', {
    staticClass: "site-content__wrapper"
  }, [_c('div', {
    staticClass: "site-content"
  }, [_c('h2', {
    staticClass: "not-found-title"
  }, [_vm._v("400")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("返回上一页")]), _vm._v(" "), _c('el-button', {
    staticClass: "not-found-btn-gohome",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'home'
        })
      }
    }
  }, [_vm._v("进入首页")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "not-found-desc"
  }, [_vm._v("抱歉！您访问的页面"), _c('em', [_vm._v("失联")]), _vm._v("啦 ...")])
}]}

/***/ }),

/***/ 506:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 507:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('SignCanvas', {
    ref: "SignCanvasRef",
    attrs: {
      "signName": _vm.nameList[_vm.nameIndex]
    },
    on: {
      "sureHandler": _vm.sureSignHandler
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 508:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": __webpack_require__(472),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_vm._v("电子签名完成，请返回电脑端继续操作！")])])
}]}

/***/ }),

/***/ 513:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 514:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 92:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export audienceLogin */
/* harmony export (immutable) */ __webpack_exports__["b"] = insertPic;
/* harmony export (immutable) */ __webpack_exports__["a"] = fileUpload;
/* unused harmony export audienceRegister */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_request__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);



function audienceLogin(params) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: '/user/login',
    method: 'post',
    data: __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify(params)
  });
}
function insertPic(params) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: '/sysPic/insertPic',
    method: 'post',
    data: params
  });
}
function fileUpload(data) {
  console.log(data);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: '/file/upload',
    method: 'post',
    data: data,
    headers: { 'Content-Type': 'multipart/form-data' }
  });
}
function audienceRegister(params) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: '/user/audienceRegister',
    method: 'post',
    data: __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify(params)
  });
}

/***/ })

},[347]);


// WEBPACK FOOTER //
// static/js/app.f9cf7894ef5a7b2f08f8.js